import React from 'react';
import styles from './tabs.module.scss';
import {Link, useSearchParams} from 'react-router-dom';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    disabled: boolean;
    name: string;
    tabs: Array<{id: string; link: React.ReactNode; child: React.ReactNode}>;
    wide?: boolean;
}

export function Tabs(props: OwnProps) {
    const [params] = useSearchParams();
    const activeTabId = params.get(`${props.name}_active_tab`);
    const activeTab = props.tabs.find((t) => t.id === activeTabId) ?? props.tabs[0];

    return (
        <div
            className={classNames(styles.tabs, {
                [styles.wide]: props.wide,
            })}
        >
            <div className={styles.tabs_menu}>
                {props.tabs.map((tab) => {
                    return (
                        <Link
                            preventScrollReset={true}
                            aria-disabled={props.disabled}
                            className={`${styles.tab_link} ${tab === activeTab ? styles.active_tab_link : styles.inactive_tab_link}`}
                            key={`${tab.id}_link`}
                            to={`?${props.name}_active_tab=${tab.id}`}
                        >
                            {tab.link}
                        </Link>
                    );
                })}
            </div>
            <div className={styles.tabs_content}>
                {props.tabs.map((tab) => {
                    return (
                        <div
                            key={`${tab.id}_content`}
                            className={`${styles.tab_container} ${tab === activeTab ? styles.active_tab : styles.inactive_tab}`}
                        >
                            {tab.child}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
